import Dropdown from "react-bootstrap/Dropdown";

export function VehicleTextField({
  label,
  id,
  name,
  placeholder,
  value,
  onChange,
  disabled,
  required = true,
  uppercase = false,
  className = "input form-control required",
}) {
  const displayValue = value ? (uppercase ? String(value).toUpperCase() : value) : "";
  return (
    <div className="group-1 group-vehicle-info">
      <div className="label">{label}:</div>
      <input
        type="text"
        placeholder={placeholder}
        id={id}
        name={name || id}
        className={className}
        value={displayValue}
        onChange={(e) => {
          const next = uppercase ? e.target.value.toUpperCase() : e.target.value;
          onChange(next);
        }}
        required={required}
        disabled={disabled}
      />
    </div>
  );
}

/**
 * @param {object} props
 * @param {Array<{value: any, label: string, active?: boolean}> | Array<string>} props.options
 * @param {any} [props.selectedValue] - when options are strings, marks the matching option active
 */
export function VehicleSelectDropdown({
  label,
  id,
  name,
  toggleLabel,
  options,
  selectedValue,
  disabled,
  onSelect,
  error,
  errorMessage,
  toggleClassName = "vehicle-weight-dropdown-toggle",
  menuVariant = "light",
  dropdownClassName = "dropdown vehicle-weight-dropdown",
  itemClassName = "vehicle-weight-dropdown-item",
  placeholderClassName = "",
}) {
  return (
    <div className="group-1 group-vehicle-info">
      <div className="label">{label}:</div>
      <div id={id} name={name || id} className={`input required ${error ? "error-msg" : ""}`}>
        <Dropdown className={dropdownClassName}>
          <Dropdown.Toggle
            variant="light"
            className={`${toggleClassName} ${placeholderClassName}`.trim()}
            disabled={disabled}
            id={id ? `${id}-toggle` : undefined}
          >
            {toggleLabel}
          </Dropdown.Toggle>
          <Dropdown.Menu variant={menuVariant}>
            {options.map((option, index) => {
              const isString = typeof option === "string";
              const optionLabel = isString ? option : option.label;
              const active = isString ? option === selectedValue : !!option.active;
              const key = isString ? option : (option.key ?? option.value ?? index);
              return (
                <Dropdown.Item
                  key={key}
                  className={itemClassName}
                  active={active}
                  onClick={() => onSelect(option, index)}
                >
                  {optionLabel}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
        {error && errorMessage ? <div className="error-msg">{errorMessage}</div> : null}
      </div>
    </div>
  );
}
